var map = {
	"./backcard.png": 39446,
	"./mayores/el-carro.jpg": 51234,
	"./mayores/el-carro.png": 1714,
	"./mayores/el-colgado.jpg": 95028,
	"./mayores/el-colgado.png": 56684,
	"./mayores/el-diablo.jpg": 54237,
	"./mayores/el-diablo.png": 56833,
	"./mayores/el-emperador.jpg": 37944,
	"./mayores/el-emperador.png": 71635,
	"./mayores/el-ermitanio.jpg": 30092,
	"./mayores/el-hermitaño.png": 10559,
	"./mayores/el-juicio.jpg": 84360,
	"./mayores/el-juicio.png": 76622,
	"./mayores/el-loco.jpg": 54470,
	"./mayores/el-loco.png": 33710,
	"./mayores/el-mago.jpg": 26710,
	"./mayores/el-mago.png": 15260,
	"./mayores/el-mundo.jpg": 64962,
	"./mayores/el-mundo.png": 4201,
	"./mayores/el-papa.jpg": 34900,
	"./mayores/el-papa.png": 99523,
	"./mayores/el-sol.jpg": 12792,
	"./mayores/el-sol.png": 44914,
	"./mayores/la-emperatriz.jpg": 62490,
	"./mayores/la-emperatriz.png": 80916,
	"./mayores/la-estrella.jpg": 48390,
	"./mayores/la-estrella.png": 82617,
	"./mayores/la-fuerza.jpg": 3170,
	"./mayores/la-fuerza.png": 65906,
	"./mayores/la-justicia.jpg": 86877,
	"./mayores/la-justicia.png": 45717,
	"./mayores/la-luna.jpg": 79366,
	"./mayores/la-luna.png": 18680,
	"./mayores/la-muerte.jpg": 12358,
	"./mayores/la-muerte.png": 19974,
	"./mayores/la-rueda-de-la-fortuna.jpg": 50699,
	"./mayores/la-rueda-de-la-fortuna.png": 80715,
	"./mayores/la-sacerdotisa.jpg": 91742,
	"./mayores/la-sacerdotisa.png": 93623,
	"./mayores/la-templanza.jpg": 62085,
	"./mayores/la-templanza.png": 45675,
	"./mayores/la-torre.jpg": 60333,
	"./mayores/la-torre.png": 76048,
	"./mayores/los-enamorados.jpg": 67424,
	"./mayores/los-enamorados.png": 81564,
	"./menores/bastos/as.jpg": 67855,
	"./menores/bastos/caballo.jpg": 7740,
	"./menores/bastos/cinco.jpg": 27970,
	"./menores/bastos/cuatro.jpg": 21118,
	"./menores/bastos/diez.jpg": 37482,
	"./menores/bastos/dos.jpg": 77052,
	"./menores/bastos/nueve.jpg": 34954,
	"./menores/bastos/ocho.jpg": 90416,
	"./menores/bastos/reina.jpg": 62229,
	"./menores/bastos/rey.jpg": 37417,
	"./menores/bastos/seis.jpg": 50591,
	"./menores/bastos/siete.jpg": 70411,
	"./menores/bastos/sota.jpg": 13173,
	"./menores/bastos/tres.jpg": 80507,
	"./menores/copas/as.jpg": 66662,
	"./menores/copas/caballo.jpg": 89035,
	"./menores/copas/cinco.jpg": 50594,
	"./menores/copas/cuatro.jpg": 90052,
	"./menores/copas/diez.jpg": 23379,
	"./menores/copas/dos.jpg": 14987,
	"./menores/copas/nueve.jpg": 43218,
	"./menores/copas/ocho.jpg": 59012,
	"./menores/copas/reina.jpg": 43595,
	"./menores/copas/rey.jpg": 56246,
	"./menores/copas/seis.jpg": 58256,
	"./menores/copas/siete.jpg": 66327,
	"./menores/copas/sota.jpg": 1032,
	"./menores/copas/tres.jpg": 4290,
	"./menores/espadas/as.jpg": 71632,
	"./menores/espadas/caballo.jpg": 67984,
	"./menores/espadas/cinco.jpg": 3791,
	"./menores/espadas/cuatro.jpg": 63177,
	"./menores/espadas/diez.jpg": 29835,
	"./menores/espadas/dos.jpg": 3713,
	"./menores/espadas/nueve.jpg": 1980,
	"./menores/espadas/ocho.jpg": 75761,
	"./menores/espadas/reina.jpg": 42112,
	"./menores/espadas/rey.jpg": 44755,
	"./menores/espadas/seis.jpg": 99868,
	"./menores/espadas/siete.jpg": 78226,
	"./menores/espadas/sota.jpg": 88363,
	"./menores/espadas/tres.jpg": 44148,
	"./menores/oros/as.jpg": 92575,
	"./menores/oros/caballo.jpg": 29869,
	"./menores/oros/cinco.jpg": 20743,
	"./menores/oros/cuatro.jpg": 9158,
	"./menores/oros/diez.jpg": 60103,
	"./menores/oros/dos.jpg": 43058,
	"./menores/oros/nueve.jpg": 63473,
	"./menores/oros/ocho.jpg": 78399,
	"./menores/oros/reina.jpg": 15556,
	"./menores/oros/rey.jpg": 47541,
	"./menores/oros/seis.jpg": 47275,
	"./menores/oros/siete.jpg": 42910,
	"./menores/oros/sota.jpg": 51206,
	"./menores/oros/tres.jpg": 52194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43646;